<div class="row col-sm-12" style="padding-right: 0; margin-right: 0; margin-bottom: 2rem;">
  <div class="col-sm-6">
    <h3>{{ 'dashboard.events.title' | translate | titlecase }}</h3>
  </div>
  <div class="col-sm-6" style="padding-right: 0; margin-right: 0; margin-bottom: 1rem;"></div>
</div>
<div class="col-sm-12">
  <p-table [showGridlines]="true" #eventsGrid [value]="eventsList" [paginator]="false" styleClass="wl-responsive-prime-datatable">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="wl-text-right wl-prime-datatable-hidden-phone">
        <th>
          <a (click)="toggleExpandedEventList()" [ngClass]="{ 'wl-dashboard-open-close-open': showExpandedEventList }"
            [hidden]="totalEventCount < 6">
            <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-up"></span>
            <span style="font-weight: bold" *ngIf="!showExpandedEventList">{{
              'dashboard.events.show-all-events' | translate | titlecase
              }}</span>
            <span style="font-weight: bold" *ngIf="showExpandedEventList">{{
              'dashboard.events.show-five-events' | translate | titlecase
              }}</span>
          </a>
        </th>
        <th>
          <span style="font-weight: bold;">{{ 'dashboard.events.date' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold;">{{ 'dashboard.events.attendees' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold;">{{ 'dashboard.events.revenue' | translate | titlecase }}</span>
        </th>
      </tr>
      <tr class="wl-text-left wl-prime-datatable-hidden-tablet-and-bigger">
        <th>
          <a (click)="toggleExpandedEventList()" [ngClass]="{ 'wl-dashboard-open-close-open': showExpandedEventList }">
            <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-down"></span>
            <span style="font-weight: bold" *ngIf="!showExpandedEventList">{{
              'dashboard.events.show-all-events' | translate | titlecase
              }}</span>
            <span style="font-weight: bold" *ngIf="showExpandedEventList">{{
              'dashboard.events.show-five-events' | translate | titlecase
              }}</span>
          </a>
        </th>
      </tr>
    </ng-template>
    <ng-template let-event pTemplate="body">
      <tr class="wl-text-right wl-prime-datatable-hidden-phone">
        <td>
          <a [routerLink]="['/event/' + event.EventId.toString()]">{{ event.EventName }}</a>
        </td>
        <td>
          {{ event.StartDateTimeUtc | date: 'M/d/yyyy' }} {{ event.StartTime }}
          <span [hidden]="
              (event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy') && event.StartTime == event.EndTime
            ">-
            <span [hidden]="(event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy')">{{
              event.EndDateTimeUtc | date: 'M/d/yyyy'
              }}</span>
            {{ event.EndTime }}</span>
        </td>
        <td>
          {{ event.PotentialAttendees }}
        </td>
        <td>
          {{ event.TotalInvoiced | currency }}
        </td>
      </tr>
      <tr class="wl-text-left wl-prime-datatable-hidden-tablet-and-bigger">
        <td>
          <h4>
            <a [routerLink]="['/event/' + event.EventId.toString()]">{{ event.EventName }}</a>
          </h4>
          <span style="font-weight: bold">{{ 'dashboard.events.date' | translate | titlecase }}:</span>&nbsp;&nbsp;
          {{ event.StartDateTimeUtc | date: 'M/d/yyyy' }} {{ event.StartTime }}
          <span [hidden]="
              (event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy') && event.StartTime == event.EndTime
            ">
            -
            <span [hidden]="(event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy')">
              {{ event.EndDateTimeUtc | date: 'M/d/yyyy' }}
            </span>
            {{ event.EndTime }} </span><br />
          <span style="font-weight: bold"> {{ 'dashboard.events.attendees' | translate | titlecase }}:
          </span>&nbsp;&nbsp;{{
          event.PotentialAttendees
          }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.events.revenue' | translate | titlecase }}:
          </span>&nbsp;&nbsp;{{
          event.TotalInvoiced | currency
          }}<br />
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>